<tec-tile [id]="OPERATION_TYPE.FORM"
	[title]="operation.title"
	[formGroup]="group"
	[subtitle]="operation.description"
	[icon]="operation.icon">
	@if (shouldShowFormOcrOrderItem()) {
		<tec-item
			[clickeable]="false"
			[title]="
				(isFormOcrOrderAutofill()
					? 'WORKFLOWS.FORM.OPERATIONS.FORM_OCR_ORDER.DOCUMENT_TITLE'
					: 'WORKFLOWS.FORM.OPERATIONS.FORM_OCR_ORDER.MANUAL_TITLE'
				) | translate
			"
			[tagImage]="{
				icon: isFormOcrOrderAutofill() ? 'icon-AI' : 'icon-fill-form',
				status: isFormOcrOrderAutofill() ? 'control' : 'level',
			}"
		>
			@if (isFormOcrOrderAutofillConfirmed()) {
				<tec-tag
					[label]="'WORKFLOWS.FORM.OPERATIONS.FORM_OCR_ORDER.ACTIVE_TAG' | translate"
					status="success"
					size="sm"
				/>
			}
			<tec-list-detail>
				<span>{{
					(isFormOcrOrderAutofill()
						? 'WORKFLOWS.FORM.OPERATIONS.FORM_OCR_ORDER.DOCUMENT_DESCRIPTION'
						: 'WORKFLOWS.FORM.OPERATIONS.FORM_OCR_ORDER.MANUAL_DESCRIPTION'
					) | translate
				}}</span>
			</tec-list-detail>
			<tec-link
				[label]="'BUTTON.EDIT' | translate"
				(click)="openFormOcrOrderEdit()"
			></tec-link>
		</tec-item>
	}

	<tec-tile [title]="'WORKFLOWS.FORM.OPERATIONS.FORM_STEPS_TITLE' | translate"
		[subtitle]="'WORKFLOWS.FORM.OPERATIONS.FORM_STEPS_DESCRIPTION' | translate">
		@if (!formStepsArray.controls?.length) {
			<tec-empty-state
				[title]="'WORKFLOWS.FORM.OPERATIONS.FORM_STEPS_EMPTY' | translate"
				[size]="'default'"
				[labelAction]="'BUTTON.ADD' | translate"
				[type]="'empty'"
				(clickEvent)="newFormStep()"
			></tec-empty-state>
		}
		<tec-item-group>
			@for (step of formStepsArray.controls; track si; let si = $index) {
				@let stepTags = getFormStepListTags(si);
				@let presetLabel = resolveFormStepPresetTypeLabel(si);
				<tec-item
					[title]="resolveFormStepListTitle(si) || ('WORKFLOWS.FORM.OPERATIONS.MODAL_FORM_STEP.NEW_STEP' | translate)"
					[clickeable]="false"
					[sortable]="true"
					[detailAction]="
						'WORKFLOWS.FORM.OPERATIONS.MODAL_FORM_STEP.STEP_NUMBER'
							| translate: { order: formStepsArray.at(si).get('step_id')?.value }
					"
					(move)="onFormStepMove($event, si)"
				>
					@for (tag of stepTags; track tag.label) {
						<tec-tag [label]="tag.label" [status]="tag.status" [size]="tag.size" />
					}
					@if (presetLabel) {
						<tec-list-detail>
							<span>{{ presetLabel }}</span>
						</tec-list-detail>
					}
					<tec-menu [options]="workflowsHelper.formStepsMenuOpt" (valueChange)="formStepsMenuChange($event, si)">
						<tec-button-icon [icon]="'icon-more'" [type]="'default'"></tec-button-icon>
					</tec-menu>
				</tec-item>
			}
		</tec-item-group>
		@if (formStepsArray.controls?.length) {
			<tec-button [label]="'WORKFLOWS.FORM.OPERATIONS.FORM_ADD_STEP' | translate" (clickEvent)="newFormStep()"></tec-button>
		}
	</tec-tile>

	<app-workflow-form-advanced-collapse [expanded]="id">
		<div class="item-group">
			<tec-item [classes]="['item--outline']"
				[title]="'WORKFLOWS.FORM.OPERATIONS.TUTORIAL' | translate"
				[tagImage]="{icon: 'icon-AI'}">
				<tec-list-detail>
					<span>{{ 'WORKFLOWS.FORM.OPERATIONS.TUTORIAL_DESCRIPTION' | translate }}</span>
				</tec-list-detail>
				<tec-switch formControlName="tutorial" size="sm"></tec-switch>
			</tec-item>
		</div>
	</app-workflow-form-advanced-collapse>
</tec-tile>
